/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    executeAction,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    ProductDimensionAvailabilitySearchCriteria,
    ProductDimensionValueInventoryAvailability
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function addToCartAsyncQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function addToCartAsyncInput(hid: string, cartId: string): IDataServiceRequest {
    const query = addToCartAsyncQuery();
    return query.createDataServiceRequestForOperation(
        'AddToCartAsync',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            hid: hid,
            cartId: cartId
        }
    );
}

export function addToCartAsyncAsync(context: IContext, hid: string, cartId: string): AsyncResult<string> {
    const request = addToCartAsyncInput(hid, cartId);
    return callActionOrExecute<string>(request, context.callerContext);
}

// @ts-ignore
function articleControllerQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('ArticleController', 'Article', DataServiceEntities.ArticleExtensionClass, key);
}

export function createGetArticleByURLInput(url: string): IDataServiceRequest {
    const query = articleControllerQuery();
    return query.createDataServiceRequestForOperation(
        'GetArticleByURL',
        true,
        DataServiceEntities.ArticleExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IArticle' },
        { url: url }
    );
}

export function getArticleByURLAsync(context: IContext, url: string): AsyncResult<DataServiceEntities.IArticle> {
    const request = createGetArticleByURLInput(url);
    return callActionOrExecute<DataServiceEntities.IArticle>(request, context.callerContext);
}

export function createGetAllArticlesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = articleControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllArticles',
        false,
        DataServiceEntities.ArticleExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IArticle' },
        {}
    );
}

export function getAllArticlesAsync(context: IContext): AsyncResult<DataServiceEntities.IArticle[]> {
    const request = createGetAllArticlesInput(context.queryResultSettings || {});
    return executeAction<DataServiceEntities.IArticle[]>(request, context.callerContext);
}

export function createGetArticleMediaLocationsInput(queryResultSettings: IQueryResultSettings, articleIds: number[]): IDataServiceRequest {
    const query = articleControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetArticleMediaLocations',
        true,
        DataServiceEntities.ArticleMediaLocationExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IArticleMediaLocation' },
        { articleIds: articleIds }
    );
}

export function getArticleMediaLocationsAsync(
    context: IContext,
    articleIds: number[]
): AsyncResult<DataServiceEntities.IArticleMediaLocation[]> {
    const request = createGetArticleMediaLocationsInput(context.queryResultSettings || {}, articleIds);
    return callActionOrExecute<DataServiceEntities.IArticleMediaLocation[]>(request, context.callerContext);
}

// @ts-ignore
function roofControllerQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('RoofController', 'Roof', DataServiceEntities.RoofExtensionClass, key);
}

export function createGetRoofTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = roofControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetRoofTable',
        false,
        DataServiceEntities.RoofExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRoof' },
        {}
    );
}

export function getRoofTableAsync(context: IContext): AsyncResult<DataServiceEntities.IRoof[]> {
    const request = createGetRoofTableInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IRoof[]>(request, context.callerContext);
}

export function createGetRoofItemReferencesByModelInput(queryResultSettings: IQueryResultSettings, modelId: number): IDataServiceRequest {
    const query = roofControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetRoofItemReferencesByModel',
        false,
        DataServiceEntities.ItemReferenceExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IItemReference' },
        { modelId: modelId }
    );
}

export function getRoofItemReferencesByModelAsync(context: IContext, modelId: number): AsyncResult<DataServiceEntities.IItemReference[]> {
    const request = createGetRoofItemReferencesByModelInput(context.queryResultSettings || {}, modelId);
    return callActionOrExecute<DataServiceEntities.IItemReference[]>(request, context.callerContext);
}

export function createGetAllRoofItemReferencesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = roofControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllRoofItemReferences',
        false,
        DataServiceEntities.ItemReferenceExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IItemReference' },
        {}
    );
}

export function getAllRoofItemReferencesAsync(context: IContext): AsyncResult<DataServiceEntities.IItemReference[]> {
    const request = createGetAllRoofItemReferencesInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IItemReference[]>(request, context.callerContext);
}

function updateSalesOrderRequisitionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateSalesOrderRequisitionInput(
    id: string,
    terminalId: string,
    storeId: string,
    channelId: number,
    custPurchOrder: string
): IDataServiceRequest {
    const query = updateSalesOrderRequisitionQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateSalesOrderRequisition',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            id: id,
            terminalId: terminalId,
            storeId: storeId,
            channelId: channelId,
            custPurchOrder: custPurchOrder
        }
    );
}

export function updateSalesOrderRequisitionAsync(
    context: IContext,
    id: string,
    terminalId: string,
    storeId: string,
    channelId: number,
    custPurchOrder: string
): AsyncResult<boolean> {
    const request = updateSalesOrderRequisitionInput(id, terminalId, storeId, channelId, custPurchOrder);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function lOBProductsControllerQuery(recordId?: number): DataServiceQuery {
    const key = recordId ? { RecordId: recordId } : null;
    return new DataServiceQuery('LOBProductsController', 'LOBProduct', DataServiceEntities.LOBProductExtensionClass, key);
}

export function createLOBGetDimensionValuesWithEstimatedAvailabilitiesInput(
    queryResultSettings: IQueryResultSettings,
    productId: number,
    criteria: ProductDimensionAvailabilitySearchCriteria
): IDataServiceRequest {
    const query = lOBProductsControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'LOBGetDimensionValuesWithEstimatedAvailabilities',
        true,
        EntityClasses.ProductDimensionValueInventoryAvailabilityClass,
        'true',
        { bypassCache: 'get', returnEntity: 'Entities.ProductDimensionValueInventoryAvailability' },
        { productId: productId, criteria: criteria }
    );
}

export function lOBGetDimensionValuesWithEstimatedAvailabilitiesAsync(
    context: IContext,
    productId: number,
    criteria: ProductDimensionAvailabilitySearchCriteria
): AsyncResult<ProductDimensionValueInventoryAvailability[]> {
    const request = createLOBGetDimensionValuesWithEstimatedAvailabilitiesInput(context.queryResultSettings || {}, productId, criteria);
    return callActionOrExecute<ProductDimensionValueInventoryAvailability[]>(request, context.callerContext);
}
